// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import {
  getSafeGatewayUssdCode,
  getSafeGatewayBankCode,
  getSafeGatewayPaymentCode,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';

export function UssdPage(): Node {

  return (
    <Root>
      <Body>
        <RenderMessageByBankCode />
      </Body>
    </Root>
  );
}

function RenderMessageByBankCode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const bankCode = getSafeGatewayBankCode(incomingPayment);
  const ussdCode = getSafeGatewayUssdCode(incomingPayment);
  const paymentCode = getSafeGatewayPaymentCode(incomingPayment);

  switch(bankCode) {
    case '058': // guaranty_trust_bank
      return (<>
        Dial the USSD CODE <b>{ussdCode}</b> number on your mobile phone.<br /><br />
        Dial the payment code <b>{paymentCode}</b> to complete the payment
      </>);

    default:
      return (<>
        Dial the number below on your mobile phone to complete the payment<br /><br />
        <b>{ussdCode}</b>
      </>);
  }
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 0;
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
  margin-bottom: 32px;
  border-bottom: 1px solid #eaedf1;
`;
